/**
 * Утилиты для генерации уникальных имен полей
 */

/**
 * Генерирует уникальное имя поля на основе базового имени
 * @param {Array<string>} existingNames - массив существующих имен полей
 * @returns {string} - уникальное имя поля
 */
export const generateUniqueFieldName = (schema) => {

  const existingFieldNames = extractFieldNamesFromSchema(schema); 
  // Создаем Set для быстрого поиска (с учетом регистра)
  const existingNamesSet = new Set(existingFieldNames.map(name => name.toLowerCase()));
  

  let baseName = 'Новое_поле'  
  // Если имя уникально, возвращаем его
  if (!existingNamesSet.has(baseName.toLowerCase())) {
    return baseName;
  }
  
  // Ищем уникальное имя с числовым суффиксом
  let counter = 1;
  let uniqueName;
  do {
    uniqueName = `${baseName}_${counter}`;
    counter++;
  } while (existingNamesSet.has(uniqueName.toLowerCase()) && counter < 1000);
  
  return uniqueName;
};


/**
 * Извлекает имена полей из JSON Schema
 * @param {Object} schema - JSON Schema
 * @returns {Array<string>} - массив имен полей
 */
export const extractFieldNamesFromSchema = (schema) => {
  if (!schema || !schema.properties) {
    return [];
  }
  
  return Object.keys(schema.properties);
};



/**
 * Проверяет, является ли имя поля валидным
 * @param {string} fieldName - имя поля для проверки
 * @returns {Object} - результат проверки { isValid: boolean, errors: Array }
 */
export const validateFieldName = (fieldName) => {
  const errors = [];
  
  if (!fieldName || typeof fieldName !== 'string') {
    errors.push('Имя поля должно быть непустой строкой');
    return { isValid: false, errors };
  }
  
  if (fieldName.trim() === '') {
    errors.push('Имя поля не может быть пустой строкой');
  }
  
  if (fieldName.length > 100) {
    errors.push('Имя поля не может быть длиннее 100 символов');
  }
  
  if (!/^[a-zA-Zа-яА-Я_][a-zA-Z0-9а-яА-Я_]*$/.test(fieldName)) {
    errors.push('Имя поля может содержать только буквы, цифры и подчеркивания, и должно начинаться с буквы или подчеркивания');
  }
  
  if (fieldName.startsWith('_') && fieldName.length === 1) {
    errors.push('Имя поля не может состоять только из подчеркивания');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

